import { sessionToken } from './sessionToken';

const API_ORIGIN = 'https://api.vss.data.calo.app';

/** The access token the api.vss front door takes as the Bearer. */
const BEARER_TOKEN = 'accessToken';

/** The seven api.vss paths of the consumer guide, and the read-only calibration route. */
export const VSS_PATHS = {
  lastProcessedTimestamp: '/video-analytics-api/metrics/last-processed-timestamp',
  roomOccupancy: '/video-analytics-api/metrics/occupancy/roi/mutually-exclusive',
  fovHistogram: '/video-analytics-api/metrics/occupancy/fov/histogram',
  tripwireHistogram: '/video-analytics-api/metrics/tripwire/histogram',
  incidents: '/video-analytics-api/incidents',
  sensorList: '/vst/api/v1/sensor/list',
  sensorStreams: '/vst/api/v1/sensor/streams',
  calibration: '/calibration'
} as const;

type VssPath = (typeof VSS_PATHS)[keyof typeof VSS_PATHS];

/** Every failure of a call, or of a response that is not JSON, carries this message and no response text. */
export class VssRequestError extends Error {
  constructor() {
    super('Kitchen vision request failed');
    this.name = 'VssRequestError';
  }
}

/** GET `path` with the user's token and return the parsed JSON body. */
export const vssGet = async (path: VssPath, query: Record<string, string> = {}): Promise<unknown> => {
  const token = await sessionToken(BEARER_TOKEN);
  const url = new URL(path, API_ORIGIN);
  url.search = new URLSearchParams(query).toString();
  try {
    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` }, credentials: 'omit' });
    if (response.ok) {
      return await response.json();
    }
  } catch {
    // Reported below with the fixed message; the cause can carry the URL or the response.
  }
  throw new VssRequestError();
};
